import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { I18nProvider } from "./i18n";
import { AuthProvider } from "./lib/auth";
import { NoticesProvider } from "./lib/notices";
import { PwaProvider } from "./lib/pwa";
import { ThemeProvider } from "./lib/theme";
import { ToastProvider } from "./components/ui";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <I18nProvider>
          <PwaProvider>
            <AuthProvider>
              <NoticesProvider>
                <ToastProvider>
                  <App />
                </ToastProvider>
              </NoticesProvider>
            </AuthProvider>
          </PwaProvider>
        </I18nProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>
);
